import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import './App.css';
// Styles
// CoreUI Icons Set
import '@coreui/icons/css/coreui-icons.min.css';
// Import Flag Icons Set
import 'flag-icon-css/css/flag-icon.min.css';
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application
import './scss/style.css';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Containers
import { DefaultLayout } from './containers';
// Pages
import { Login, Page404, Page500, Register, Landing, About, FAQ, Contact } from './views/Pages';
import { AppGuide, Architecture, CustomDev, Ecommerce, Education, Entertainment} from './views/Pages';
import { Feature, Media, Medical, PlatformGuide, Pricing, Privacy, RealEstate} from './views/Pages';
import { Retail, Sports, Support, ToS, Training, Travel} from './views/Pages';

// import { renderRoutes } from 'react-router-config';

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route  path="/" exact name="Home" component={DefaultLayout} />
          <Route  path="/dashboard" name="Home" component={DefaultLayout} />
          <Route  path="/create"  name="Home" component={DefaultLayout} />
          <Route  path="/build" name="Home" component={DefaultLayout} />
          <Route  path="/manage" name="Home" component={DefaultLayout} />
          <Route  path="/grow" name="Home" component={DefaultLayout} />
          <Route  path="/addons" name="Home" component={DefaultLayout} />
          <Route  path="/analytics" name="Home" component={DefaultLayout} />
          <Route  path="/setting" name="Home" component={DefaultLayout} />
          <Route  path="/preview" name="Home" component={DefaultLayout} />
          <Route  path="/about" name="Login Page" component={About} />
          <Route  path="/contact" name="Login Page" component={Contact} />
          <Route  path="/faq" name="Login Page" component={FAQ} />
          <Route  path="/login" name="Login Page" component={Login} />
          <Route  path="/home" name="Home" component={Landing} />
          <Route  path="/register" name="Register Page" component={Register} />
          <Route  path="/500" name="Page 500" component={Page500} />
          /* Footer pages */
          <Route  path="/appguide" name="Application Guide" component={AppGuide} />
          <Route  path="/architecture" name="Architecture" component={Architecture} />
          <Route  path="/customdev" name="Custom Development" component={CustomDev} />
          <Route  path="/ecommerce" name="Ecommerce" component={Ecommerce} />
          <Route  path="/education" name="Education" component={Education} />
          <Route  path="/entertainment" name="Entertainment" component={Entertainment} />
          <Route  path="/feature" name="Feature" component={Feature} />
          <Route  path="/media" name="Media" component={Media} />
          <Route  path="/medical" name="Medical" component={Medical} />
          <Route  path="/platformguide" name="Platform Guide" component={PlatformGuide} />
          <Route  path="/pricing" name="Pricing" component={Pricing} />
          <Route  path="/privacy" name="Privacy" component={Privacy} />
          <Route  path="/realestate" name="Real Estate" component={RealEstate} />
          <Route  path="/retail" name="Retail" component={Retail} />
          <Route  path="/sports" name="Sports" component={Sports} />
          <Route  path="/support" name="Support" component={Support} />
          <Route  path="/tos" name="Terms of Service" component={ToS} />
          <Route  path="/training" name="Training" component={Training} />
          <Route  path="/travel" name="Travel" component={Travel} />
          
          <Route  path="*" component={Page404} />
        </Switch>
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js